export function normalizeDateInput(input: string, isFormatTime?: boolean) {
    if (!input) return '';

    // Tách ngày tháng và thời gian
    let [datePart, timePart] = input.trim().split(' ');

    // Chuyển tất cả dấu phân cách trong ngày tháng thành "/"
    datePart = datePart.replace(/[-.]/g, '/');

    // Tách ngày, tháng, năm
    const dateParts = datePart.split('/');
    if (dateParts.length !== 3) return input; // Nếu không đúng format, trả lại nguyên bản

    let [day, month, year] = dateParts.map((part) => part.trim());

    // Thêm số 0 nếu thiếu
    if (day.length === 1) day = '0' + day;
    if (month.length === 1) month = '0' + month;

    // Kiểm tra năm có đủ 4 ký tự không
    if (year.length !== 4) return input;

    if (!isFormatTime) return `${day}/${month}/${year}`;

    // Mặc định thời gian là 00:00:00 nếu không có
    if (!timePart) timePart = '00:00:00';

    // Tách giờ, phút, giây
    let timeParts = timePart.split(':');
    let [hour = '00', minute = '00', second = '00'] = timeParts.map((t) =>
        t.trim()
    );

    // Chuẩn hóa giờ phút giây thành 2 chữ số
    if (hour.length === 1) hour = '0' + hour;
    if (minute.length === 1) minute = '0' + minute;
    if (second.length === 1) second = '0' + second;

    return `${day}/${month}/${year} ${hour}:${minute}:${second}`;
}
